<template>
  <jet-dropdown align="right" width="96">
    <template #trigger>
      <span class="inline-flex rounded-md">
        <button type="button" class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out bg-white border border-transparent rounded-md hover:text-gray-700 focus:outline-none">
          <span class="relative inline-block">
            <font-awesome-icon :icon="['fas', 'bell']" />
            <span v-if="notifications.length != 0" class="absolute top-0 right-0 inline-flex items-center justify-center px-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full" v-text="notifications.length" />
          </span>

          <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </span>
    </template>

    <template #content>
      <jet-dropdown-link v-for="(n, index) in notifications" :key="n.id" :href="`/notifications/${n.id}`" :class="{ 'bg-blue-50': ! n.read_at }">
        <button type="button" class="inline-flex items-start justify-center float-right px-2 py-1 text-gray-400 rounded-md hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" @click.stop.prevent="remove(index)">
          <font-awesome-icon :icon="['fas', 'times']" size="xs" />
        </button>
        {{ n.data.message }}
      </jet-dropdown-link>

      <div v-if="notifications.length == 0" class="block px-4 py-2 text-sm text-gray-700">
        You currently have no notifications.
      </div>

      <notification-toast :notification="toastingNotification" />
    </template>
  </jet-dropdown>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import NotificationToast from '@/Magis/Components/NotificationToast'

export default {
  components: {
    JetDropdown,
    JetDropdownLink,
    NotificationToast,
  },

  data () {
    return {
      notifications: window.NOTIFICATIONS,
      toastingNotification: null,
    }
  },

  mounted () {
    window.Echo.private(`App.Models.User.${this.$page.props.user.id}`)
      .notification(notification => {
        if (notification.type === 'NotificationRead') {
          const readNotification = this.notifications.find(n => n.id === notification.read_id)
          readNotification.read_at = moment().toISOString()
        } else if (notification.type === 'NotificationDeleted') {
          const deletedNotificationIndex = this.notifications.findIndex(n => n.id === notification.deleted_id)
          if (deletedNotificationIndex >= 0) {
            this.notifications.splice(deletedNotificationIndex, 1)
          }
        } else {
          this.toast(notification)
          this.notifications.unshift({
            id: notification.id,
            read_at: null,
            data: { message: notification.message },
          })
        }
      })
  },

  methods: {
    toast (notification) {
      this.toastingNotification = notification

      setTimeout(() => {
        this.toastingNotification = null
      }, 3000)
    },

    remove (index) {
      const notificationToBeRemoved = this.notifications[index]
      this.notifications.splice(index, 1)
      axios.delete(`/notifications/${notificationToBeRemoved.id}`)
    },
  },
}
</script>
